import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import policies from "../policies";
import { STORE_CONFIG } from "../config/store";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const groups = [policies.slice(0, 7), policies.slice(7, 14), policies.slice(14)];
  return <footer className="site-footer" role="contentinfo">
    <div className="footer-main">
      <div className="footer-column contact-column">
        <div className="footer-brand"><span aria-hidden="true">f</span>{STORE_CONFIG.brand}</div>
        <p>Home and everyday goods with clear product and care specifications.</p>
        <p>Operating region: {STORE_CONFIG.operatingRegion}</p>
        <a className="contact-email" href={`mailto:${STORE_CONFIG.customerServiceEmail}`}>{STORE_CONFIG.customerServiceEmail}</a>
      </div>
      {groups.map((group, index) => <div className="footer-column" key={index}>
        <h4>{index === 0 ? "Orders" : index === 1 ? "Products" : "Store"}</h4>
        <ul>{group.map((policy) => <li key={policy.slug}><Link to={`/policies/${policy.slug}`} onClick={toTop}>{policy.title}</Link></li>)}</ul>
      </div>)}
    </div>
    <div className="footer-bottom">
      <p className="copyright">© 2026 {STORE_CONFIG.brand}. {STORE_CONFIG.operatingRegion}. No public street address has been confirmed.</p>
      <div className="payment-methods" aria-label="Supported payment method"><span>Secure hosted</span><strong>CARD</strong><small>{STORE_CONFIG.currency}</small></div>
    </div>
  </footer>;
}
export default Footer;
